var State = /* @__PURE__ */ ((State2) => {
  State2[State2["IDLE"] = 0] = "IDLE";
  State2[State2["ACTIVE"] = 1] = "ACTIVE";
  State2[State2["DONE"] = 2] = "DONE";
  State2[State2["UNSUBSCRIBED"] = 3] = "UNSUBSCRIBED";
  State2[State2["ERROR"] = 4] = "ERROR";
  return State2;
})(State || {});
var CloseMode = /* @__PURE__ */ ((CloseMode2) => {
  CloseMode2[CloseMode2["NEVER"] = 0] = "NEVER";
  CloseMode2[CloseMode2["FIRST"] = 1] = "FIRST";
  CloseMode2[CloseMode2["LAST"] = 2] = "LAST";
  return CloseMode2;
})(CloseMode || {});
export {
  CloseMode,
  State
};
